import { CheckoutState } from '../../state';
import {
    areAsyncExpressCheckoutEligibleCommonRulesMet,
    isGooglePayAvailableAsExpressPaymentMethod,
} from '../expressCheckoutConditions';

export const areAsyncExpressGooglePayEligibleRulesMet = (
    state: CheckoutState,
) =>
    areAsyncExpressCheckoutEligibleCommonRulesMet(state) &&
    isGooglePayAvailableAsExpressPaymentMethod(state);
